import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useState } from 'react';

import { isCampaignDetailLimitMet } from '@/api/campaign';
import { type OpportunityStatusOldType } from '@/api/opportunity';
import { Panel } from '@/components/panels';
import { Tabs, TabsList, TabsTrigger } from '@/components/Tabs';
import { OpportunityInfluenceChartTableCombo } from '@/features/OpportunityInfluenceChartTableCombo';

type Props = {
  campaignIds?: string[];
  isLoading?: boolean;
};

const CampaignOpportunityInfluenceChartTable = ({
  campaignIds,
  isLoading: isCampaignLoading,
}: Props) => {
  const [opportunityType, setOpportunityType] = useState<OpportunityStatusOldType>('pipeline');

  const options: { value: OpportunityStatusOldType; label: string }[] = [
    { value: 'pipeline', label: t`Pipeline` },
    { value: 'closedWon', label: t`Closed Won` },
  ];

  return (
    <Panel
      title={<Trans>Opportunity Influence</Trans>}
      noPadding
      actions={
        <Tabs
          value={opportunityType}
          onValueChange={(value) => setOpportunityType(value as OpportunityStatusOldType)}
        >
          <TabsList>
            {options.map((option) => (
              <TabsTrigger key={option.value} value={option.value}>
                {option.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      }
    >
      <OpportunityInfluenceChartTableCombo
        opportunityType={opportunityType}
        isLoading={isCampaignLoading}
        canExecuteQuery={isCampaignDetailLimitMet(campaignIds)}
        campaignIds={campaignIds}
      />
    </Panel>
  );
};

export default CampaignOpportunityInfluenceChartTable;
